import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#E20074', //magenta
                secondary: '#000000', //Negro
                terciary: '#4C4C4C', //negro segundo
                fondo: '#2E2E2E',
                accent: '#28A745', //Verde
                cancel: '#F44336',
                error: '#A21E4D',

                done: '#D8AA00', //mostasa
            }
        },
        options: {
            customProperties: true,
        },
    }
});